import IdentifyCustomers from '@/views/Admin/IdentifyCustomers/IdentifyCustomers.vue';
import { Route } from '../route.model';

const adminIdentifyCustomers = new Route(
  '/admin/identify-customers',
  'admin_identify_customers',
  IdentifyCustomers,
  {
    requiresAuth: true,
    superRoot: true,
    navbar: {
      name: 'Identify Customers',
      icon: 'credit-card'
    },
    zendesk: {
      disabled: true
    }
  }
);

export { adminIdentifyCustomers };
export default adminIdentifyCustomers;
